module.exports = __webpack_public_path__ + "static/australian-gold-dc4d7ee741f04e54a1880c74e3bf3ea5.jpg";